export default "__VITE_ASSET__C32oeavB__"